import GenericRequest, { METHOD_POST } from '../../../webservices/GenericRequest';
import { ApiEndpoints } from '../../../webservices/endpoint';

export class ResourceContractorSchemaAsCompanyListTask extends GenericRequest {

    _request; // ResourceContractorSchemaListRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.DOCUMENTS_SCHEMAS_BY_CONTRACTOR_AS_COMPANY);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/predefined-fields/resource-contractor-schema/ResourceContractorSchemaAsCompanyListTask.js